export default "__VITE_ASSET__CK3IY22s__"